// src/context/AuthContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth'; // Importe 'signOut'
import { auth } from '../firebase'; // Verifique se seu firebase.js exporta 'auth'

// Cria o contexto
const AuthContext = createContext();

// Hook customizado para facilitar o uso do contexto
export const useAuth = () => {
  return useContext(AuthContext);
};

// Componente Provedor que irá envolver toda a aplicação
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // Função de Logout que será usada pelo botão "Sair"
  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    // onAuthStateChanged "escuta" em tempo real se o usuário está logado ou não
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      
      if (user) {
        // Se o usuário existe, busca o token para ler os "claims" (cargos/roles)
        try {
          const idTokenResult = await user.getIdTokenResult();
          // Define o cargo (ex: 'admin') ou null se não houver
          setUserRole(idTokenResult.claims.role || null);
        } catch (error) {
          console.error("Erro ao buscar o cargo do usuário:", error);
          setUserRole(null);
        }
      } else {
        // Se não há usuário, limpa o cargo
        setUserRole(null);
      }
      
      setLoading(false); // Finaliza o carregamento inicial
    });

    // Função de limpeza para remover o "escutador" quando o componente não for mais usado
    return unsubscribe;
  }, []);

  // Valor que será disponibilizado para toda a aplicação
  const value = {
    currentUser,
    userRole,
    logout, // <-- A função logout agora está sendo fornecida aqui!
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};